module.exports = __webpack_public_path__ + "img/image-mark-shuttleworth.995026f4.png";